const MetedStaticData = {
 MetedStats: [
    { id: 1, name: 'MetEd Users Worldwide', value: '+880,000' },
    { id: 2, name: 'Countries & Territories Served', value: '+190' },
    { id: 3, name: 'Lessons Published on MetEd', value: '+1,000' },
  ],
  testimonials: [
    {
      id: 1,
      body: 'I\'m always using this info. Both on the line and off. Knowing what kinds of fuels are in your area can help in the event of an evacuation for civilians and what we might encounter in fire behavior.',
      author: {
        name: 'read more',
        handle: 'read more',
        imageUrl:
          '',
      },
    },
    {
        id: 2,
        body: 'I\'m a flight instructor in a leadership position.  Weather principles, along with how to spot and avoid hazardous weather, are key safety "teaching points" that I try to pass on to both students and instructors.',
        author: {
          name: 'read more',
          handle: 'read more',
          imageUrl:
            '',
        },
      },
      {
        id: 3,
        body: 'To provide more accurate weather and storm information to the network of individuals and agencies charged with protecting our local and regional community.',
        author: {
          name: 'read more',
          handle: 'readmore',
          imageUrl:
            '',
        },
      },
    // More testimonials...
  ],
  latestFeatured: [
          {
            id: 1,
            title: 'Satellite Analysis of Fog in Warm Water Areas',
            href: 'https://learn.meted.ucar.edu/#/online-courses/4c142c6f-618e-40cc-aac8-76306ff256ea',
            description:
              'Satellite imagery can provide valuable insight into current atmospheric phenomena, especially in data-sparse areas over the ocean. The identification and monitoring of near-shore, offshore, and high seas fog poses a number of challenges, including limited... ',
            date: 'March 30, 2025',
            datetime: '2025-03-30',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/4c142c6f-618e-40cc-aac8-76306ff256ea/module-cover-10328(1).jpg",
            category: { title: 'Lesson', href: '/lessons' },
          },
          {
            id: 2,
            title: 'Forecasting Blowing Snow',
            href: 'https://learn.meted.ucar.edu/#/online-courses/b18a2d0d-0ca4-47e1-9363-00bcf5a8485d',
            description:
              'Blowing snow occurs when snow and ice particles near the surface combine with strong winds and gusts to significantly reduce visibility. Blowing snow can lead to hazardous blizzard conditions that profoundly impact those in their path, posing risks to transportation,... ',
            date: 'March 27, 2025',
            datetime: '2025-03-27',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/b18a2d0d-0ca4-47e1-9363-00bcf5a8485d/module-cover-10318(1).jpg",
            category: { title: 'Lesson', href: '/lessons' },
          },
          {
            id: 3,
            title: 'ASOS and AWOS Explained: Key Differences, Similarities and Uses',
            href: 'https://learn.meted.ucar.edu/#/online-courses/794f6479-67a9-4676-b50d-5e0115fbbf5c',
            description:
              'The Automated Surface Observing System (ASOS) and Automated Weather Observing Systems (AWOS) are vital components of aviation safety and meteorological data. These automated systems continuously monitor and deliver real time weather data including wind speed... ',
            date: 'February 25, 2025',
            datetime: '2025-02-25',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/794f6479-67a9-4676-b50d-5e0115fbbf5c/module-cover-10339.jpg",
            category: { title: 'Lesson', href: '/lessons' },
          },
          
        ],
  latestFeaturedSpanish: [
      {
            id: 1,
            title: 'Cómo comunicar pronósticos probabilísticos',
            href: 'https://learn.meted.ucar.edu/#/online-courses/bdfec82c-08bb-48e9-8d38-9ae226da9b66',
            description:
              'La capacidad de comunicar la información probabilística de manera eficaz es un aspecto importante que el Servicio Nacional de Meteorología (National Weather Service, NWS) de los EE. UU. desea desarrollar cada vez más en su personal. Esta lección permite adquirir práctica en comunicar la información probabilística al público y a las agencias y personas a cargo de tomar decisiones.... ',
            date: '16 de septiembre de 2024',
            datetime: '2024-09-16',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/bdfec82c-08bb-48e9-8d38-9ae226da9b66/module-cover-10337(1).jpg",
            category: { title: 'Lesson', href: '/lessons' },
          },
          {
            id: 2,
            title: 'Conceptos básicos de integración de datos satelitales y de PNT',
            href: 'https://learn.meted.ucar.edu/#/online-courses/2e95f1a7-9adc-4980-a0b7-dc9ffd7abbf5',
            description:
              'La predicción numérica del tiempo (PNT) es una de las principales herramientas de pronóstico que tenemos a nuestra disposición. Sin embargo, identificar dónde y cuándo el modelo no capta la realidad es difícil. Para los pronósticos a corto plazo, es importante identificar dónde y cuándo la representación del modelo no coincide con la realidad a fin de poder aplicar los cambios... ',
            date: '9 de septiembre de 2024',
            datetime: '2024-09-09',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/2e95f1a7-9adc-4980-a0b7-dc9ffd7abbf5/module-cover-10334(1).jpg",
            category: { title: 'Lesson', href: '/lessons' },
          },
          {
            id: 3,
            title: 'Fundamentos de las estaciones hidrométricas — Aguas bajas',
            href: 'https://learn.meted.ucar.edu/#/online-courses/794f6479-67a9-4676-b50d-5e0115fbbf5c',
            description:
              'Esta lección prepara al personal técnico en hidrología para la eventualidad de encontrar condiciones de aguas bajas durante una visita de campo a una estación hidrométrica. Tales condiciones pueden conducir a situaciones particulares, como acumulaciones de algas y la obstrucción o el entierro del orificio del manómetro de burbuja.... ',
            date: '30 de junio de 2024',
            datetime: '2024-06-30',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/79c93d66-9576-4deb-9de4-d567226e8990/module-cover-10287.jpg",
            category: { title: 'Lesson', href: '/lessons' },
          },
  ],
}

export default MetedStaticData;